module.exports = __webpack_public_path__ + "img/2.bc0146fa.svg";